import { createContext, useContext } from "react";
const ThemeSchemeContext = createContext({});
const TitleThemeSchemeContext = createContext({});
const useThemeScheme = ({
  scheme,
  theme,
  themeContent,
  themeControls
}) => {
  const themeScheme = useContext(ThemeSchemeContext);
  return {
    scheme,
    theme,
    themeContent,
    themeControls,
    ...themeScheme
  };
};
export {
  ThemeSchemeContext,
  TitleThemeSchemeContext,
  useThemeScheme
};
//# sourceMappingURL=ThemeSchemeContext.js.map
